import { IMG } from "../data/content";
import { FadeUp, SectionHead, Img } from "./Reveal";

export const About = () => (
  <section id="about" data-testid="about-section" className="relative py-24 lg:py-36 bg-forest-900/40 overflow-hidden">
    <span
      aria-hidden="true"
      className="absolute -top-6 right-0 font-serif italic text-[16vw] leading-none text-outline opacity-30 pointer-events-none select-none whitespace-nowrap"
    >
      HiddenBiomes
    </span>
    <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div className="relative">
          <FadeUp>
            <div className="relative h-[420px] lg:h-[540px] overflow-hidden">
              <Img src={IMG.tigerJungle} alt="Tiger in jungle light" className="w-full h-full object-cover" />
              <div className="absolute inset-0 border border-gold/15" />
            </div>
          </FadeUp>
          <FadeUp delay={0.2} className="absolute -bottom-8 -right-2 sm:right-8 w-44 sm:w-56">
            <div className="overflow-hidden border-2 border-forest-950 shadow-2xl shadow-black/60">
              <Img src={IMG.glamping} alt="Luxury forest camp" className="w-full h-40 sm:h-48 object-cover" />
            </div>
          </FadeUp>
        </div>

        <div>
          <SectionHead
            num="06"
            eyebrow="About HiddenBiomes"
            title="More Than a Journey. An Experience."
          />
          <FadeUp delay={0.2}>
            <p className="mt-6 text-base text-cream/70 leading-relaxed">
              HiddenBiomes LLP is a travel and tourism company focused on
              creating memorable wildlife, adventure, nature and travel
              experiences. We help travellers discover destinations through
              thoughtfully planned journeys, local experiences and comfortable
              travel arrangements.
            </p>
            <p className="mt-5 text-base text-cream/70 leading-relaxed">
              Based in Indore, at the very heart of India, we build journeys
              through the forests, rivers and monuments of Madhya Pradesh —
              with the patience the wild deserves and the planning a great
              journey demands.
            </p>
          </FadeUp>
          <FadeUp delay={0.3}>
            <div className="mt-10 grid grid-cols-3 gap-6 border-t border-gold/15 pt-8">
              {[
                ["23+", "Destinations"],
                ["6", "Tiger Reserves"],
                ["100%", "Custom Planned"],
              ].map(([n, l]) => (
                <div key={l}>
                  <span className="font-serif text-3xl sm:text-4xl text-gold">{n}</span>
                  <span className="block font-mono text-[10px] uppercase tracking-[0.2em] text-fog mt-2">
                    {l}
                  </span>
                </div>
              ))}
            </div>
          </FadeUp>
        </div>
      </div>
    </div>
  </section>
);
